<template>
  <div class="content-box">
    <div class="page-title">
      当前位置：首页 > 帐号设置
    </div>
    <div class="content-info">
      <div class="set-info">
        <div class="set-title">
          <span :class="{active:tab=== 1}" @click="tab = 1">修改密码</span>
          <span :class="{active:tab=== 2}" @click="tab = 2">修改手机号</span>
        </div>
        <div class="set-account" v-if="tab === 1">
          <div class="login-input flex-center">
            <i>手机号</i>
            <el-input v-model="phone" placeholder="请输入手机号" class="login-item" disabled></el-input>
          </div>
          <div class="login-input flex-center">
            <i>验证码</i>
            <el-input v-model="smsCode" placeholder="请输入验证码" class="login-item"></el-input>
            <div class="code-text" @click="sendCode">
              {{ codeText }} <span v-if="typeof codeText === 'number'">秒后重新发送</span>
            </div>
          </div>
          <div class="login-input flex-center">
            <i>旧密码</i>
            <el-input type="password" v-model="oldPass" placeholder="请输入旧密码" class="login-item"></el-input>
          </div>
          <div class="login-input flex-center">
            <i>新密码</i>
            <el-input type="password" v-model="newPass" placeholder="请输入新密码" class="login-item"></el-input>
          </div>
          <div class="login-input flex-center">
            <i>确认密码</i>
            <el-input type="password" v-model="rnewPass" placeholder="请确认再次密码" class="login-item"></el-input>
          </div>
          <el-button type="primary" class="login-submit-btn" @click="setSubmit" :disabled="submitState">立即修改
          </el-button>
        </div>
        <div class="set-account" v-if="tab === 2">
          <div class="login-input flex-center">
            <i>原手机号</i>
            <el-input v-model="phone" placeholder="请输入手机号" class="login-item" disabled></el-input>
          </div>
          <div class="login-input flex-center">
            <i>验证码</i>
            <el-input v-model="smsCode" placeholder="请输入验证码" class="login-item"></el-input>
            <div class="code-text" @click="sendCode">
              {{ codeText }} <span v-if="typeof codeText === 'number'">秒后重新发送</span>
            </div>
          </div>
          <div class="login-input flex-center">
            <i>新手机号</i>
            <el-input v-model="newPhone" placeholder="请输入手机号" class="login-item"></el-input>
          </div>
          <el-button type="primary" v-if="tab === 1" class="login-submit-btn" @click="setSubmit" :disabled="submitState">立即修改
          </el-button>
          <el-button type="primary" v-if="tab === 2" class="login-submit-btn" @click="setPhone" :disabled="submitState">立即修改
          </el-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "seting",
  data() {
    return {
      tab: 1,
      phone: '',
      newPhone:'',
      smsCode: '',
      codeText: '获取验证码', // 验证码文字
      id: null, // 计时器id
      timeId: null, // 一次性计时器id
      oldPass: '',
      newPass: '',
      rnewPass: '',
      submitState: false
    }
  },
  created() {
    this.$emit('setIndex', 3)
    this.phone = this.$store.state.user.phone
  },
  methods: {
    setPhone(){
      this.submitState = true
      if (!this.smsCode) {
        this.$message.error('请输入验证码')
        this.submitState = false
        return
      }
      if (!this.newPhone) {
        this.$message.error('请输入新手机号')
        this.submitState = false
        return
      }
      if (this.$tools.checkTel(this.newPhone)) {
        this.$message.error('新手机号格式错误，请确认')
        this.submitState = false
        return
      }
      this.$api.apiContent.editPhone({
        token: this.$store.state.user.token,
        phone: this.phone,
        code: this.smsCode,
        new_phone: this.newPhone,
      }).then(() => {
        this.$message({
          message: '修改成功,请重新登录',
          type: 'success',
          duration: 1000
        });
        setTimeout(() => {
          this.$store.state.user = null
          this.$router.push('/login')
        }, 1500)

      }).catch(e => {
        this.$message.error(e.msg)
        this.submitState = false
      })
    },
    setSubmit() {
      this.submitState = true
      if (!this.phone) {
        this.$message.error('请输入手机号')
        this.submitState = false
        return
      }
      if (this.$tools.checkTel(this.phone)) {
        this.$message.error('手机号格式错误，请确认')
        this.submitState = false
        return
      }
      if (!this.smsCode) {
        this.$message.error('请输入验证码')
        this.submitState = false
        return
      }
      if (!this.oldPass) {
        this.$message.error('请输入旧密码')
        this.submitState = false
        return
      }
      if (!this.newPass) {
        this.$message.error('请输入新密码')
        this.submitState = false
        return
      }
      if (this.newPass !== this.rnewPass) {
        this.$message.error('两次密码不一致')
        this.submitState = false
        return
      }
      this.$api.apiContent.userSetPass({
        token: this.$store.state.user.token,
        phone: this.phone,
        code: this.smsCode,
        oldpass: this.oldPass,
        pass: this.newPass,
        repass: this.rnewPass,
      }).then(() => {
        this.$message({
          message: '修改成功,请重新登录',
          type: 'success',
          duration: 1000
        });
        setTimeout(() => {
          this.$store.state.user = null
          this.$router.push('/login')
        }, 1500)

      }).catch(e => {
        this.$message.error(e.msg)
        this.submitState = false
      })
    },
    //  获取验证码
    sendCode() {
      if (!this.phone) {
        this.$message.error('请输入手机号')
        this.submitState = false
        return
      }
      if (this.$tools.checkTel(this.phone)) {
        this.$message.error('手机号格式错误，请确认')
        this.submitState = false
        return
      }
      if (this.codeText === '获取验证码' || this.codeText === '重新发送') {
        this.codeText = 60
        this.id = setInterval(() => {
          if (this.codeText === 0) {
            clearInterval(this.id)
            this.codeText = '重新发送'
            return
          }
          if (typeof this.codeText === 'number') {
            this.codeText--
          }
        }, 1000)
        this.$api.apiContent.sendMsg({
          phone: this.phone,
          token: this.$store.state.user.token,
        }).then().catch(e => {
          this.$message.error(e.msg)
          this.codeText = '重新发送'
          clearInterval(this.id)
        })
      }
    }
  },
  watch:{
    tab(){
      clearInterval(this.id)
      this.codeText = '获取验证码'
      if(this.tab === 2){
        this.phone = this.$store.state.user.phone
      }
    }
  }
}
</script>

<style scoped lang="scss">
.content-info {
  min-height: 950px;
  .set-info {
    width: 800px;
    margin: 0 auto;
    padding: 50px 0;

    .set-title {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 500px;
      margin: 0 auto;

      span {
        display: block;
        width: 150px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border: 1px solid #f9aa0d;
        color: #f9aa0d;
        border-radius: 20px;
        font-size: 16px;
        cursor: pointer;

        &.active {
          background: #f9aa0d;
          color: #fff;
        }
      }
    }
    .set-account {
      padding: 50px;
      .login-input {
        height: 40px;
        border-radius: 4px;
        margin-bottom: 20px;

        i {
          display: block;
          width: 100px;
          text-align: right;
          padding-right: 15px;
        }

        .login-item {
          flex: 1;

          input {
            background: transparent;

          }
        }

        .link-text {
          display: block;
          width: 60px;
          height: 41px;
          text-align: left;
          line-height: 41px;
          background: #fff;
          margin: 0 20px;
          color: #f9aa0d;
        }

        .code-img {
          width: 116px;
          height: 41px;
          background: #fff;
          margin: 0 20px;
        }

        .code-text {
          width: 116px;
          height: 41px;
          text-align: center;
          line-height: 41px;
          color: #fff;
          background: #f9aa0d;
          margin: 0 20px;
          border-radius: 5px;
          cursor: pointer;
          overflow: hidden;
        }
      }
      .login-submit-btn{
        display: block;
        margin: 0 auto;
        background: #f9aa0d;
        border:1px solid #f9aa0d;
      }
    }
  }
}
</style>
